// The API refresh response contains only a message. The current role is in
// the new access token; decoding it here is for UI state, not authorization.
export const getTokenRole = (token: string): string => {
  const payload = token.split(".")[1];
  const { r: role } = JSON.parse(
    atob(payload.replace(/-/g, "+").replace(/_/g, "/")),
  );
  if (typeof role !== "string" || !role) {
    throw new Error("No role received from refresh");
  }
  return role;
};
